// extracted by mini-css-extract-plugin
export default {"wrapper":"Form_wrapper__fRIIw","form-group":"Form_form-group__Wp3RK"};